<template>
    <PopupRouterView :showLeftIcon="true" label="Surat Jalan Delivery Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="suratjalandelivery"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="suratJalanDeliveryInput">


        <b-card header="Surat Jalan" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Surat Jalan Number" :model="model.suratJalanNumber" v-if="!model.isManualNumber" />
						<app-input-textbox :id="'fieldset-surat-jalan-number'" label-cols-lg="12" label="Surat Jalan Number" size="sm" :model.sync="model.suratJalanNumber" @change="updateData" :isRequired="true" :isEditable="model.mainRecordId != null ? false : true" v-if="model.isManualNumber" />
						<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction" size="sm" :model.sync="model.deliveryInstructionId" :isRequired="true" :selected="model.deliveryInstruction != null ? model.deliveryInstruction.diNumber : ''" @input="getDeliveryInstructions" :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstruction" :isUpdatable ="null" />
						<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate" :isRequired="true" :state="validateState('deliveryDate')" :errorMessage="getErrorMessage(errorMessage.deliveryDate, 'deliveryDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="true" :isUpdatable ="false"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Customer" id="fieldset-customer" size="sm" :model.sync="model.customerId" :isRequired="true" :state="validateState('customerId')" :errorMessage="getErrorMessage(errorMessage.customerId, 'customerId')"   :selected="model.customer != null ? model.customer.code : ''" @input="getCustomers" @change="updateData" :isEditable="false" :isUpdatable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedCustomer" />
						<app-input-combobox-autocomplete :options="customers" optionsLabel="code" optionsKey="id" label-cols-lg="12" label="Destination" id="fieldset-destination" size="sm" :model.sync="model.destinationId" :isRequired="true" :state="validateState('destinationId')" :errorMessage="getErrorMessage(errorMessage.destinationId, 'destinationId')"   :selected="model.destination != null ? model.destination.code : ''" @input="getCustomers" @change="updateData" :isEditable="false" :isUpdatable ="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedDestination" />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isUpdatable ="null"/>
				</b-col>

            </b-row>
        </b-card>

        <b-card header="Driver Information" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-driver-name" label-cols-lg="12"  label="Driver Name" label-for="input-driver-name" size="sm" :model.sync="model.driverName"  @change="updateData" :isUpdatable ="null"/>
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-vehicle-number" label-cols-lg="12"  label="Vehicle Number" label-for="input-vehicle-number" size="sm" :model.sync="model.vehicleNumber"  @change="updateData" :isUpdatable ="null"/>
				</b-col>

            </b-row>
        </b-card>

		<app-table-input 
			title = "List Part to Delivery"
			:bordered="true" :items="suratJalanDeliveryDetails" 
			:fields="fieldsSuratJalanDeliveryDetail" 
			:busy="isDataLoading" 
			:sort-by.sync="sortBySuratJalanDeliveryDetail" 
			:sort-desc.sync="sortDescSuratJalanDeliveryDetail" small responsive	
			@editButtonMethod="editRowDataSuratJalanDeliveryDetail"	
			@deleteButtonMethod="deleteRowDataSuratJalanDeliveryDetail"	
			@showPopupAddMethod="addDataSuratJalanDeliveryDetail()"	
			@showPopupUploadMethod="showPopupUploadSuratJalanDeliveryDetail()"
			@downloadMethod="downloadSuratJalanDeliveryDetail()"
			@addFromClipboardMethod="addFromClipboardSuratJalanDeliveryDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardSuratJalanDeliveryDetail()"
			:showActionButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadSuratJalanDeliveryDetail"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowSuratJalanDeliveryDetailFilter = !isShowSuratJalanDeliveryDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowSuratJalanDeliveryDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Delivery Card">
					<v-select id="input-surat-jalan-delivery-detail-delivery-card-table" append-to-body label="deliveryCardNumber" :options="deliveryInstructionDeliveryCards" :value="filterSuratJalanDeliveryDetail.deliveryCardId" :reduce="item => item.id" v-model="filterSuratJalanDeliveryDetail.deliveryCardId" @search="getDeliveryInstructionDeliveryCards" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select id="input-surat-jalan-delivery-detail-part-table" append-to-body label="partNumber" :options="parts" :value="filterSuratJalanDeliveryDetail.partId" :reduce="item => item.id" v-model="filterSuratJalanDeliveryDetail.partId" @search="getParts" :filterable ="true"></v-select>
				</b-th>
				<b-th stacked-heading="Order Qty">
					<b-form-input id="input-surat-jalan-delivery-detail-order-qty-table" v-model="filterSuratJalanDeliveryDetail.orderQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Delivery Qty">
					<b-form-input id="input-surat-jalan-delivery-detail-delivery-qty-table" v-model="filterSuratJalanDeliveryDetail.deliveryQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Checklist Loading">
					<b-form-checkbox id="input-surat-jalan-delivery-detail-is-loading-table" class="float-right" v-model="filterSuratJalanDeliveryDetail.isLoading"></b-form-checkbox>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( suratJalanDeliveryDetailPageSize * (currentSuratJalanDeliveryDetailPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(deliveryCard)="row">
				<app-input-combobox-autocomplete :options="deliveryInstructionDeliveryCards" optionsLabel="deliveryCardNumber" optionsKey="id" :id="'input-surat-jalan-delivery-detail-delivery-card-' + row.index" label-cols-lg="12" label="Delivery Card" size="sm" :model.sync="row.item.deliveryCardId"  @change="saveInputSuratJalanDeliveryDetail(row.item)" :selected="row.item.deliveryCard != null ? row.item.deliveryCard.deliveryCardNumber : ''"  @input="getDeliveryInstructionDeliveryCards" :loading="isDeliveryInstructionDeliveryCardComboLoading" :isEditable="false" :isUpdatable ="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(part)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-surat-jalan-delivery-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputSuratJalanDeliveryDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading" :isEditable="false" :isUpdatable ="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(orderQty)="row">
				<app-input-textbox :id="'input-surat-jalan-delivery-detail-order-qty-' + row.index" label-cols-lg="12" label="Order Qty" size="sm" :model.sync="row.item.orderQty"   @change="saveInputSuratJalanDeliveryDetail(row.item)" :isUpdatable ="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(deliveryQty)="row">
				<app-input-textbox :id="'input-surat-jalan-delivery-detail-delivery-qty-' + row.index" label-cols-lg="12" label="Delivery Qty" size="sm" :model.sync="row.item.deliveryQty"   @change="saveInputSuratJalanDeliveryDetail(row.item)" :isUpdatable ="false" :isEditable="false" :nolabel="true" />
			</template>
			<template v-slot:cell(isLoading)="row">
				<app-input-checkbox :id="'input-surat-jalan-delivery-detail-is-loading-row-' + row.index" label-cols-lg="12" :model.sync="row.item.isLoading" @change="saveInputSuratJalanDeliveryDetail(row.item)" :isUpdatable ="null"  :nolabel="true"></app-input-checkbox>
			</template>

			<template v-slot:form-add-detail>
				<SuratJalanDeliveryDetailInput 
					:model="modelSuratJalanDeliveryDetail"
					:openPopup="isShowPopupSuratJalanDeliveryDetail"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataSuratJalanDeliveryDetail"/>
			</template>
			<template v-slot:upload-detail>
					<SuratJalanDeliveryDetailUpload
					:openPopup="isShowPopupUploadSuratJalanDeliveryDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataSuratJalanDeliveryDetail"
					:parentId="modelId"
					/>
			</template>
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentSuratJalanDeliveryDetailPage"
				:total-rows="totalSuratJalanDeliveryDetailRow"
				:per-page="suratJalanDeliveryDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>

		<template #modal-action-button>
			<b-button size="sm" variant="outline-success" @click="onHidden">Cancel</b-button>
			<b-button size="sm" class="btn-fill-success float-right" @click="checkDate">
				<b-icon-plus-square class="mr-1"></b-icon-plus-square>
				Save
			</b-button>
		</template>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterView>
</template><script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SuratJalanDelivery from '@/models/SuratJalanDelivery/SuratJalanDelivery';
import SuratJalanDeliveryList from '@/models/SuratJalanDelivery/SuratJalanDeliveryList';
import SuratJalanDeliveryFilter from '@/filters/SuratJalanDelivery/SuratJalanDeliveryFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import Customer from '@/models/Customer/Customer';
import CustomerFilter from '@/filters/Customer/CustomerFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import SuratJalanDeliveryDetail from '@/models/SuratJalanDelivery/SuratJalanDeliveryDetail';
import SuratJalanDeliveryDetailFilter from '@/filters/SuratJalanDelivery/SuratJalanDeliveryDetailFilter';
import DeliveryInstructionDeliveryCard from '@/models/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCard';
import DeliveryInstructionDeliveryCardFilter from '@/filters/DeliveryInstructionDeliveryCard/DeliveryInstructionDeliveryCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputCheckbox from '@/components/AppInputCheckbox';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import SuratJalanDeliveryDetailInput from '@/views/SuratJalanDelivery/SuratJalanDeliveryDetailInput';
import SuratJalanDeliveryDetailUpload from '@/views/SuratJalanDelivery/SuratJalanDeliveryDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		AppInputCheckbox,
		SuratJalanDeliveryDetailInput,SuratJalanDeliveryDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			deliveryDate: {required},
			customerId: {required},
			destinationId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				deliveryDate: { required : "Delivery Date is Required."},
				customerId: { required : "Customer is Required."},
				destinationId: { required : "Destination is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsSuratJalanDeliveryDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"deliveryCard": { "class" : "th-delivery-card first-child", "label" : "Delivery Card", key: 'deliveryCard', sortable: false}}, 
				{"part": { "class" : "th-part", "label" : "Part", key: 'part', sortable: false}}, 
				{"orderQty": { "class" : "th-order-qty last-child", "label" : "Order Qty", key: 'orderQty', sortable: false}}, 
				{"deliveryQty": { "class" : "th-delivery-qty d-stack-none", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false}}, 
				{"isLoading": { "class" : "th-is-loading d-stack-none", "label" : "Checklist Loading", key: 'isLoading', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelSuratJalanDeliveryDetail : {},
			isShowPopupSuratJalanDeliveryDetail : false,
			isShowPopupUploadSuratJalanDeliveryDetail : false,
			filterSuratJalanDelivery : null,
			currentSuratJalanDeliveryPage : 1,
			suratJalanDeliveryPageSize: 10,
			sortBySuratJalanDelivery: '',
			sortDescSuratJalanDelivery: '',
			filterSuratJalanDeliveryDetail : null,
			currentSuratJalanDeliveryDetailPage : 1,
			suratJalanDeliveryDetailPageSize: 10,
			sortBySuratJalanDeliveryDetail: '',
			sortDescSuratJalanDeliveryDetail: '',
			sortingBySuratJalanDeliveryDetail: [],
			suratJalanDeliveryDetails : [],
			suratJalanDeliveryDetailId : '',
			totalSuratJalanDeliveryDetailRow : 0,
			isShowSuratJalanDeliveryDetailFilter: false,
			isDownloadSuratJalanDeliveryDetail: false,
			deliveryInstructionDeliveryCards: [],
			parts: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			customers: [],
			isCustomerComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isSuratJalanDeliveryComboLoading: false,
			isDeliveryInstructionDeliveryCardComboLoading: false,
			isPartComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			todayDate: new Date(),
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getSuratJalanDelivery : async function(id) {
			this.isBusy = true;
			SuratJalanDelivery.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadSuratJalanDelivery = true;
			this.filterSuratJalanDelivery.id = this.modelId;
			SuratJalanDelivery.downloadDataDetail(this, this.filterSuratJalanDelivery).then(result => {
				this.isDownloadSuratJalanDelivery = false;
			}).catch(error => { this.isDownloadSuratJalanDelivery = false; })
		},
		getSuratJalanDeliveryDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSuratJalanDeliveryDetail);
			if (this.modelId == null) return;
			filter.suratJalanDeliveryId = this.modelId;
			filter.draftMode = "1";
			if (this.sortBySuratJalanDeliveryDetail != null) {
				this.sortingBySuratJalanDeliveryDetail[this.sortBySuratJalanDeliveryDetail] = this.sortDescSuratJalanDeliveryDetail;
			}
			let currentPage = (this.currentSuratJalanDeliveryDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSuratJalanDeliveryDetailRow + 1;
				let page = Math.ceil(totalData/this.suratJalanDeliveryDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.suratJalanDeliveryDetailPageSize = 0;
			// disable paging end
			SuratJalanDeliveryDetail.getList(this, filter, this.sortingBySuratJalanDeliveryDetail, currentPage , this.suratJalanDeliveryDetailPageSize).then(result => {
				this.currentSuratJalanDeliveryDetailPage = currentPage + 1;
				this.suratJalanDeliveryDetails = result.data;
				this.totalSuratJalanDeliveryDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSuratJalanDeliverys : async function(input) {
			let filter = new SuratJalanDeliveryFilter();
			if (input != undefined) {
				filter.SuratJalanNumber = input;
			}
			this.isSuratJalanDeliveryComboLoading = true;
			SuratJalanDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.suratJalanDeliverys = result.data
				}
				this.isSuratJalanDeliveryComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDeliveryCards : async function(input) {
			let filter = new DeliveryInstructionDeliveryCardFilter();
			if (input != undefined) {
				filter.deliveryCardNumber = input;
			}
			this.isDeliveryInstructionDeliveryCardComboLoading = true;
			DeliveryInstructionDeliveryCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDeliveryCards = result.data
				}
				this.isDeliveryInstructionDeliveryCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionDetailComboLoading = true;
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
				this.isDeliveryInstructionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			// filter.fwDocStat = '0,1';
			// filter.exactType.fwDocStat = '1';
			filter.diStatusCode = 'READY_TO_DELIVERY'
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstructionExecuted(item) {
			let _this = this;
			if(item == undefined || item == null) {
				this.model.deliveryInstructionId = null;
				this.model.deliveryInstruction = null;
				this.isBusy = true;
				SuratJalanDelivery.resetDocument(this, this.model.id).then(result => {
					this.getSuratJalanDelivery(this.model.id).then(result => {
						this.getSuratJalanDeliveryDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				this.model.deliveryInstructionId = item.id;
				this.model.deliveryInstruction = item;

				this.isBusy = true;
				SuratJalanDelivery.copyFromDocument(this, 'deliveryinstruction', item.id, this.model.id).then(result => {
					this.getSuratJalanDelivery(this.model.id).then(result => {
						this.getSuratJalanDeliveryDetails();
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			}
		},
		setSelectedDeliveryInstruction(item) {
			if(item) {
				var itemId = Number(item.id);
				if(this.model.deliveryInstructionId == itemId) return;
			}

			if(this.suratJalanDeliveryDetails != null && this.suratJalanDeliveryDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap Surat Jalan Delivery akan me-reset form yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.setSelectedDeliveryInstructionExecuted(item);
					}
				})
				.catch(err => {})
			} else {
				this.setSelectedDeliveryInstructionExecuted(item);
			}
		},
		onDeliveryInstructionChange : async function() {
			let item = this.model.deliveryInstructionId;
			let deliveryInstructionObj = this.deliveryInstructions.filter(function(deliveryInstruction){ return deliveryInstruction.id == item; });
			this.model.deliveryInstruction = deliveryInstructionObj.length > 0 ? deliveryInstructionObj[0] : null;
			this.setSelectedDeliveryInstruction(this.model.deliveryInstruction);
		},
		getCustomers : async function(input) {
			let filter = new CustomerFilter();
			if (input != undefined) {
				filter.code = input;
			}
			Customer.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.customers = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedCustomer(item) {
			if(item == undefined || item == null) {
				this.model.customerId = null;
				this.model.customer = null;
			} else {
				this.model.customerId = item.id;
				this.model.customer = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDestination(item) {
			if(item == undefined || item == null) {
				this.model.destinationId = null;
				this.model.destination = null;
			} else {
				this.model.destinationId = item.id;
				this.model.destination = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.suratJalanDeliveryInput.scrollTop = 0;
		},
		async checkDate(modalEvent) {
			let deliveryDate = new Date(this.model.deliveryDate);
			let currentDate = new Date();

			console.log("deliveryDate", deliveryDate);
			console.log("currentDate", currentDate);
			console.log("result", deliveryDate > currentDate);

			if(deliveryDate > currentDate) {
				let message = "Tanggal Delivery yang dipilih lebih dari hari ini. Apakah anda tetap ingin melanjutkan?";
				if(!await this.showPopupWithMessage(message)) return;
			}

			this.saveAction(modalEvent);
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					SuratJalanDelivery.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'suratjalandeliveryindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					SuratJalanDelivery.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'suratjalandeliveryindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SuratJalanDelivery.updateData(this, model, id)
					.catch((error) => {
						this.getSuratJalanDelivery(id);
					});
				}
			});
		},
		onHidden() {
			this.getSuratJalanDeliverys();
		},
		addRowDataSuratJalanDeliveryDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.suratJalanDeliveryId =  this.modelId;
					SuratJalanDeliveryDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSuratJalanDeliveryDetails(true);
						this.isShowPopupSuratJalanDeliveryDetail = false;
					})
				} else {
					model.suratJalanDeliveryId =  this.modelId;
					SuratJalanDeliveryDetail.createDataDetail(this, model)
					.then(result => {
						this.getSuratJalanDeliveryDetails(true);
						this.isShowPopupSuratJalanDeliveryDetail = false;
					})
				}
			}
		},
		async editRowDataSuratJalanDeliveryDetail(id) {
			this.suratJalanDeliveryDetailId = id;
			this.isShowPopupSuratJalanDeliveryDetail = true; 
		},
		async deleteRowDataSuratJalanDeliveryDetail(id) {
			SuratJalanDeliveryDetail.deleteData(this, id).then(result => { this.getSuratJalanDeliveryDetails(); });
		},
		async resetDataSuratJalanDeliveryDetail() {
			this.suratJalanDeliveryDetailId = "";
			this.isShowPopupSuratJalanDeliveryDetail = true;
		},
		async addDataSuratJalanDeliveryDetail() {
			SuratJalanDeliveryDetail.createData(this, { suratJalanDeliveryId: this.modelId })
			.then(result => {
				this.getSuratJalanDeliveryDetails(true);
			})
		},
		async addFromClipboardSuratJalanDeliveryDetail() {
			let deliveryCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryCards.push({ deliveryCard: item, suratJalanDeliveryId: this.modelId });
				});
				SuratJalanDeliveryDetail.addFromClipboard(this, deliveryCards).then(result => { this.getSuratJalanDeliveryDetails() });
			});
		},
		async replaceFromClipboardSuratJalanDeliveryDetail() {
			let deliveryCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryCards.push({ deliveryCard: item, suratJalanDeliveryId: this.modelId });
				});
				SuratJalanDeliveryDetail.replaceFromClipboard(this, deliveryCards).then(result => { this.getSuratJalanDeliveryDetails() });
			});   
		},
		showPopupUploadSuratJalanDeliveryDetail() {
			if(this.suratJalanDeliveryDetails != null && this.suratJalanDeliveryDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap SuratJalanDeliveryDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadSuratJalanDeliveryDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadSuratJalanDeliveryDetail = true;
			}
		},
		uploadDataSuratJalanDeliveryDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSuratJalanDeliveryDetail = false; 
		},
		downloadSuratJalanDeliveryDetail(modalEvent) {
			this.isDownloadSuratJalanDeliveryDetail = true;
			this.filterSuratJalanDeliveryDetail.suratJalanDeliveryId = this.modelId;
			SuratJalanDeliveryDetail.downloadDataDetail(this, this.filterSuratJalanDeliveryDetail).then(result => {
				this.isDownloadSuratJalanDeliveryDetail = false;
			}).catch(error => { this.isDownloadSuratJalanDeliveryDetail = false; })
		},
		saveInputSuratJalanDeliveryDetail(item) {
			if (this.suratJalanDeliverys != null && this.suratJalanDeliverys != undefined  && this.suratJalanDeliverys.length > 0) {
				item.suratJalanDelivery = this.suratJalanDeliverys.find(q => q.id == item.suratJalanDeliveryId);
			}
			if (this.deliveryInstructionDeliveryCards != null && this.deliveryInstructionDeliveryCards != undefined  && this.deliveryInstructionDeliveryCards.length > 0) {
				item.deliveryCard = this.deliveryInstructionDeliveryCards.find(q => q.id == item.deliveryCardId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
				item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SuratJalanDeliveryDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadSuratJalanDeliveryDetail = false; 
			this.isShowPopupSuratJalanDeliveryDetail = false; 
			if (modalType == 'SuratJalanDeliveryDetail') {
				this.getSuratJalanDeliveryDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowSuratJalanDeliveryDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterSuratJalanDelivery = new SuratJalanDeliveryFilter();
		this.filterSuratJalanDeliveryDetail = new SuratJalanDeliveryDetailFilter();
		//this.getSuratJalanDeliverys();
		//this.getDeliveryInstructionDeliveryCards();
		//this.getParts();
		//this.getDeliveryInstructionDetails();
		//this.getDeliveryInstructions();
		//this.getCustomers();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getSuratJalanDelivery(id);
			} else {
				this.modelId = id;
				this.getSuratJalanDelivery(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				return true;
			}
		}
	},
	watch : {
		sortBySuratJalanDeliveryDetail : {
			handler: function() {
				this.getSuratJalanDeliveryDetails();
			}
		},
		sortDescSuratJalanDeliveryDetail: {
			handler: function() {
				this.getSuratJalanDeliveryDetails();
			}
		},
		currentSuratJalanDeliveryDetailPage: {
			handler: function() {
				this.getSuratJalanDeliveryDetails();
			}
		},
		suratJalanDeliveryDetailPageSize : {
			handler: function() {
				this.getSuratJalanDeliveryDetails();
			}
		},
		filterSuratJalanDeliveryDetail: {
			handler: function() {
				this.getSuratJalanDeliveryDetails();
			},
			deep: true,
		},
	},
}
</script>
